<template>
  <div v-if="!iszoomed && !hasHidden" class="zoom-note">
    <img :src="require(`images/boundaries/zoom-icon.svg`)" alt="">
    <p>Pinch the screen to zoom and move.</p>
  </div>
</template>

<script>
import throttle from 'lodash/throttle'

export default {
  props: ['iszoomed'],
  data () {
    return {
      hasHidden: false
    }
  },
  methods: {
    checkVisible () {
      const el = this.$el

      if (!el.getBoundingClientRect || this.hasHidden) return

      const rect = el.getBoundingClientRect()
      const isVisible = rect.bottom > (rect.height * 0.3) &&
        rect.right > 0 &&
        rect.left < (window.innerWidth || document.documentElement.clientWidth) /* or $(window).width() */ &&
        rect.top < (window.innerHeight || document.documentElement.clientHeight) /* or $(window).height() */

      if (isVisible) {
        setTimeout(() => {
          this.hasHidden = true
        }, 5000)
      }
      return isVisible
    }
  },
  mounted () {
    const self = this
    document.addEventListener('scroll', throttle(function () {
      self.checkVisible()
    }, 100))

    this.$el.addEventListener('touchstart', () => {
      this.hasHidden = true
    }, false)
  }
}
</script>
<style lang="scss" scoped>
.zoom-note {
  z-index: 1;
  width: 220px;
  padding: 20px 10px 10px;
  border-radius: 10px;
  background-color: rgba(255, 255, 255, 0.9);
  text-align: center;
  position: absolute;
  top: 40%;
  left: 50%;
  transform: translate(-50%, -40%);

  @include breakpoint($d_small) {
    display: none;
  }

  p {
    font-size: 13px;
    font-family: $font-OpenSans-Regular;
  }
  img {
    width: 20px;
    animation: zoom_animation 2s linear infinite;
  }
}
@keyframes zoom_animation {
  0% {
    transform: scale(1);
  }
  60% {
    transform: scale(1.3);
  }
}
</style>
